import React from "react";

const LANGS = ["es", "en", "pt"];

export function LanguageSwitcher({ language, changeLanguage, className = "" }) {
  return (
    <div className={`lang-pill ${className}`}>
      {LANGS.map((lang) => (
        <button
          key={lang}
          type="button"
          className={`lang-pill__btn${language === lang ? " active" : ""}`}
          onClick={() => changeLanguage(lang)}
        >
          {lang.toUpperCase()}
        </button>
      ))}
    </div>
  );
}
